const colors = {
  primary: 'gray.900',
  primaryText: 'white',
  white: 'white',
  gray: 'gray.100',
  light: 'green.200',
  dark: 'green.600',
  doubleDark: 'green.700'
}


// Shared design tokens, matching the public marketing site (public-site/styles.css,
// Direction 2 "Studio"). Added alongside the legacy `colors` export rather than
// replacing it — `colors` is imported by ~20 views and changing its keys would
// restyle half the app unintentionally.
const theme = {
  green: '#237049',
  greenDark: '#103726',
  greenTint: '#f1f7f3',
  ink: '#111815',
  text: '#3b453f',
  muted: '#6f7a73',
  faint: '#a4ada7',
  line: '#e6eae7',
  line2: '#eff2f0',
  danger: '#b4232a',
}

const containerWidth = [
  '100%', // 0-30em
  '80%', // 30em-48em
  '75%', // 48em-62em
  '65%', // 62em+
]

export {
  colors,
  theme,
  containerWidth
}
